import { render, staticRenderFns } from "./StoresListComp.vue?vue&type=template&id=98aa26de&scoped=true&"
import script from "./StoresListComp.vue?vue&type=script&lang=js&"
export * from "./StoresListComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98aa26de",
  null
  
)

export default component.exports